var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuoImport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    width: "1em",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0 0 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.32285 2.96471C9.24493 3.02445 9.1706 3.08954 9.10044 3.15975L4.75129 7.51162C4.68186 7.58109 4.61745 7.65463 4.55827 7.73169H8.57461C8.98903 7.73169 9.3249 7.39557 9.32461 6.98115L9.32285 2.96471Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09277 9.23169V17.2335C4.09277 18.4761 5.10013 19.4835 6.34277 19.4835H14.6414C15.884 19.4835 16.8914 18.4761 16.8914 17.2335V4.75024C16.8914 3.5076 15.884 2.50024 14.6414 2.50024H10.8226L10.8246 6.98008C10.8254 8.22325 9.81781 9.23169 8.57461 9.23169H4.09277Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.1577 5.43304C19.5719 5.43304 19.9077 5.76883 19.9077 6.18304V17.75C19.9077 20.3733 17.781 22.5 15.1577 22.5H7.79883C7.38461 22.5 7.04883 22.1642 7.04883 21.75C7.04883 21.3358 7.38461 21 7.79883 21H15.1577C16.9526 21 18.4077 19.5449 18.4077 17.75V6.18304C18.4077 5.76883 18.7435 5.43304 19.1577 5.43304Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuoImport);
export default __webpack_public_path__ + "static/media/DuoImport.4c78a534f1f6e858242031a516b43ac3.svg";
export { ForwardRef as ReactComponent };